import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ReactNode } from 'react';
import jwt from 'jwt-decode';
import { useAuth0Data } from 'neon-auth0';
import { ActionOwnerName } from '../utils/actionOwnerName';
import { useAxiosMiddleware } from '../hooks/useAxiosMiddleware';

interface Props {
  children: ReactNode;
}

export const ReactQueryProvider = ({ children }: Props) => {
  const { accessToken } = useAuth0Data();
  const decodedToken: any = jwt(accessToken);
  const key = decodedToken?.iss + 'neonUserId';
  ActionOwnerName.setNeonUserId(decodedToken[key]!);
  const { isReady } = useAxiosMiddleware();

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false
      }
    }
  });

  if (!isReady) return <></>;

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      {children}
    </QueryClientProvider>
  );
};
